import { Component, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import type { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import { CommonModule } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'sme-offer-budgetbill[offer]',
  templateUrl: './offer-budgetbill-sme.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CommonModule, JssModule, ToolTipComponent, RoundedCurrencyPipe],
})
export class OfferBudgetbillSmeComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer!: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | undefined;

  get showBudgetBillBefore() {
    const showFromAmount = getFieldValue<boolean>(
      this.rendering,
      'ShowFromToAmount',
      false
    );

    return showFromAmount && (this.offer?.discountPrice || 0) > 0;
  }
}
